import React, { useEffect, useRef, useState } from 'react';
import '../assets/allnft/css/style.css';
import Layout from '../component/Layout';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BACKEND_URL, TOKEN_SYMBOL, URI_PREFIX, api } from '../hooks/constant';
import NftModal from '../component/NftModal';
import { useMintStats, usePurchaseStats } from '../stats/useStats';
import { formatPrice } from '../hooks/contractHelper';
import audioImg from '../assets/images/music-banner.jpg';
import playImg from '../assets/images/play.png';
import pausedImg from '../assets/images/pause.png';
import logoImg from '../assets/images/logo.png';
import usdtImg from '../assets/images/usdt.webp';
import Header from '../component/Header';
import Countdown, { zeroPad } from "react-countdown";


export default function AllNFTs() {
    const [category, setCategory] = useState([]);
    const [categoryId, setCategoryId] = useState({
        id: 0,
        name: ''
    });
    const [nftdata, setNftdata] = useState([]);
    const [modalShow, setModalShow] = React.useState(false);
    const [updater, setUpdater] = useState(1)
    const minStats = useMintStats(updater)
    const purchaseStats = usePurchaseStats(updater)
    const [selectedNft, setSelectedNft] = useState({});
    const [bannerImg, setBannerImg] = useState('')
    const [drawDate, setDrawDate] = useState('')
    const [playingAudio, setPlayingAudio] = useState(null);
    const audioRefs = useRef([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedId, setSelectedId] = useState(1);
    const scrollRef = useRef(null);
    const [settings, setSettings] = useState({});



    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const onWheel = (e) => {
            if (e.deltaY === 0) return;
            e.preventDefault(); // prevent vertical scroll
            el.scrollLeft += e.deltaY;
        };

        el.addEventListener('wheel', onWheel, { passive: false });

        return () => el.removeEventListener('wheel', onWheel);
    }, []);

    useEffect(() => {
        async function fetch() {
            const response = await api.get('get_banner')

            if (response && response.data && response.data) {
                setBannerImg(response.data.setting.value)
                setDrawDate(response.data.draw_date.value)
            }
        }

        fetch()
    }, []);

    useEffect(() => {
        async function fetch() {
            const response = await api.post('get_category')

            if (response && response.data && response.data.data) {
                setCategory(response.data.data)
                response.data.data[0] && response.data.data[0].id && setCategoryId({
                    id: response.data.data[0].id,
                    name: response.data.data[0].title
                })
            }
        }

        fetch()
    }, []);


    useEffect(() => {
        async function fetch() {
            const response = await api.get('get_settings')

            if (response && response.data && response.data.data) {
                let finalData = response.data.data.reduce((acc, item) => {
                    acc[item.name] = item.value;
                    return acc;
                }, {});

                setSettings(finalData);

            }
        }

        fetch()
    }, []);




    useEffect(() => {
        async function fetch() {
            const response = await api.post('get_nft?page=' + currentPage, {
                "per_page": 60,
                "sort_by": "desc",
                "category_id": categoryId
            });

            if (response && response.data) {
                setNftdata(response.data.data);
                setCurrentPage(response.data.current_page);
                setTotalPages(response.data.last_page);
            }
        }

        fetch();
    }, [categoryId, currentPage])


    const playAudio = (index) => {
        if (playingAudio !== null) {
            audioRefs.current[playingAudio].pause();
        }
        audioRefs.current[index].play();
        setPlayingAudio(index);
    };

    const stopAudio = (index) => {
        audioRefs.current[index].pause();
        audioRefs.current[index].currentTime = 0;
        setPlayingAudio(null);
    };

    useEffect(() => {
        // Load external script for countdown widget
        const script = document.createElement("script");
        script.src = "https://cdn.logwork.com/widget/countdown.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [settings]);


    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            return (
                <div className="d-flex justify-content-center gap-3 flex-wrap">
                    <div className="p-3 border rounded text-center">
                        <h5 className="mb-0">00</h5>
                        <small className="text-white">Days</small>
                    </div>
                    <div className="p-3 border rounded text-center">
                        <h5 className="mb-0">00</h5>
                        <small className="text-white">Hours</small>
                    </div>
                    <div className="p-3 border rounded text-center">
                        <h5 className="mb-0">00</h5>
                        <small className="text-white">Minutes</small>
                    </div>
                    <div className="p-3 border rounded text-center">
                        <h5 className="mb-0">00</h5>
                        <small className="text-white">Seconds</small>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="d-flex justify-content-center gap-3 flex-wrap countdown-section">
                    <div className="px-5 py-2 border rounded text-center">
                        <h5 className="mb-0">{zeroPad(days)}</h5>
                        <small className="text-white">Days</small>
                    </div>
                    <div className="px-5 py-2 border rounded text-center">
                        <h5 className="mb-0">{zeroPad(hours)}</h5>
                        <small className="text-white">Hours</small>
                    </div>
                    <div className="px-5 py-2 border rounded text-center">
                        <h5 className="mb-0">{zeroPad(minutes)}</h5>
                        <small className="text-white">Minutes</small>
                    </div>
                    <div className="px-5 py-2 border rounded text-center">
                        <h5 className="mb-0">{zeroPad(seconds)}</h5>
                        <small className="text-white">Seconds</small>
                    </div>
                </div>
            );
        }
    };

    return (
        <Layout>
            <Header minStats={minStats} purchaseStats={purchaseStats} categoryId={categoryId} />
            {settings && settings.enable_winner && settings.enable_winner === '2' && (
                <section class="tf-section tf-explore tf-filter">
                    <div class="tf-container">
                        <div class="row mb-5 max-w-6xl mx-auto">
                            <Countdown date={parseInt(settings?.home_timer) || 0} key={Math.random()} renderer={renderer} />
                            {/* {bannerImg && (
                                <div class="col-md-12 mb-4">
                                    <div class="tf-heading style-2 wow fadeInUp">
                                        <img src={`${BACKEND_URL}${bannerImg}`} alt='banner' className='banner-img' />
                                    </div>
                                </div>
                            )} */}
                            <div class="col-md-12 mb-4">
                                <div class="tf-heading style-2 wow fadeInUp">
                                    <h4 class="heading">Round : <span className='text-yellow'>{drawDate ? drawDate : '....'}</span></h4>
                                </div>
                            </div>
                            <div className='col-12'>
                                <div ref={scrollRef} className="scroll-hidden">
                                    <ul className="filter-menu d-flex flex-nowrap mb-0">
                                        {category && category.length > 0 &&
                                            category.map((items, index) => (
                                                index <= 10 && (
                                                    <li
                                                        key={items.id}
                                                        className={`${items.id === categoryId.id ? 'active' : ''} me-3`}
                                                        onClick={() => setCategoryId({ id: items.id, name: items.title })}
                                                    >
                                                        <a href="#sec" className="text-nowrap d-inline-block">
                                                            {items?.title}
                                                        </a>
                                                    </li>
                                                )
                                            ))}
                                    </ul>
                                </div>
                            </div>
                            {/* <div className='col-12 col-md-4'>
                            <div className='row'>
                                <div className='col-12 mt-5'>
                                    <iframe title="lottery" src="https://www.lottery.co.th/small" width="100%" height="290" frameborder="0"></iframe>
                                </div>
                                <div className='col-12 mt-5'>
                                    <YouTube videoId="2g811Eo7K8U" opts={opts} />
                                </div>
                            </div>
                        </div> */}

                            <div className="col-12 col-md-12">

                                <div class="row tf-filter-container wow fadeInUp mt-4">
                                    {nftdata && nftdata.length > 0 && nftdata.map((items, key) => {

                                        return (
                                            <div key={key} class="col-lg-4 col-md-6 col-sm-6 tf-loadmore 3d cyber">
                                                <div class="sc-product style2">
                                                    <div class="features">
                                                        <div class="product-media">
                                                            {items.file_type === "2" ? (
                                                                <video controls>
                                                                    <source src={`${URI_PREFIX}${items.image}`} type="video/mp4" />
                                                                </video>
                                                            ) : items.file_type === "3" ? (
                                                                <>
                                                                    <img src={audioImg} className='nft-img' alt="audio" />
                                                                    <audio ref={el => audioRefs.current[key] = el} src={`${URI_PREFIX}${items.image}`} type="audio/mpeg" />
                                                                    <div style={{
                                                                        position: 'absolute',
                                                                        top: '50%',
                                                                        left: '50%',
                                                                        transform: 'translate(-50%, -50%)',
                                                                        zIndex: 10
                                                                    }}>
                                                                        {playingAudio === key ? (


                                                                            <div class="wrapper" onClick={() => stopAudio(key)}>
                                                                                <div class="circle pulse"></div>
                                                                                <div class="circle">
                                                                                    <img src={pausedImg} alt='play' height="50px" width="50px" style={{
                                                                                        position: 'absolute',
                                                                                        top: '50%',
                                                                                        left: '50%',
                                                                                        transform: 'translate(-50%, -50%)',

                                                                                    }} />
                                                                                </div>
                                                                            </div>

                                                                        ) : (
                                                                            <div class="wrapper" onClick={() => playAudio(key)}>
                                                                                <div class="circle pulse"></div>
                                                                                <div class="circle" >
                                                                                    <img src={playImg} alt='play' height="24px" width="24px" style={{
                                                                                        position: 'absolute',
                                                                                        top: '50%',
                                                                                        left: '50%',
                                                                                        transform: 'translate(-50%, -50%)',

                                                                                    }} />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <img src={`${URI_PREFIX}${items.image}`} className='nft-img' alt="images" />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div class="cash">{items.name}</div>
                                                    <div class="bottom-style2 mt-2">

                                                        <div class="price">
                                                            <div class="icon">
                                                                <img src={logoImg} alt="images" />
                                                            </div>
                                                            <div class="content">
                                                                <div class="name">Price</div>
                                                                <div class="cash">{minStats.price ? formatPrice(minStats.price) : 0} {TOKEN_SYMBOL}</div>
                                                            </div>
                                                        </div>
                                                        <div className='flex gap-1'>
                                                            {items.is_purchased && items.is_purchased === 1 ? (
                                                                <button type='button' class="sold-btn">Sold</button>
                                                            ) : (
                                                                <>
                                                                    <button type='button' onClick={() => {
                                                                        setModalShow(true)
                                                                        setSelectedNft(items)
                                                                        setSelectedId(2)
                                                                    }} class="purchase-btn">
                                                                        <img src={usdtImg} alt='usdt' />
                                                                        Buy
                                                                    </button>
                                                                    <button type='button' onClick={() => {
                                                                        setModalShow(true)
                                                                        setSelectedNft(items)
                                                                        setSelectedId(1)
                                                                    }} class="purchase-btn">
                                                                        <img src={logoImg} alt='mmsc' />
                                                                        Buy
                                                                    </button>

                                                                </>
                                                            )}

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                                {nftdata && nftdata.length > 0 && (
                                    <div className="pagination mt-4 d-flex justify-content-center gap-2">
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => setCurrentPage(1)}
                                            disabled={currentPage === 1}
                                        >
                                            First
                                        </button>

                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                            disabled={currentPage === 1}
                                        >
                                            Prev
                                        </button>

                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                            <button
                                                key={page}
                                                className={`btn btn-sm ${page === currentPage ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => setCurrentPage(page)}
                                            >
                                                {page}
                                            </button>
                                        ))}

                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>

                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => setCurrentPage(totalPages)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Last
                                        </button>
                                    </div>
                                )}
                                {nftdata && nftdata.length === 0 && (
                                    <div className='row'>
                                        <div className='col-12 text-center'>
                                            <h4 className='my-5 py-5'>No record found</h4>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </section>
            )}

            {settings && settings.enable_winner && settings.enable_winner === '1' && (
                <section class="tf-section tf-explore tf-filter">
                    <div class="tf-container">
                        <div class="row mb-5 max-w-6xl mx-auto">
                            <Countdown date={parseInt(settings?.home_timer) || 0} key={Math.random()} renderer={renderer} />
                            <div className='d-flex justify-content-center mt-5'>
                                <table width="736" height="757" border="0">
                                    <tbody>
                                        <tr>
                                            <td width="100%" height="336">
                                                
                                                <iframe
                                                    width="100%"
                                                    height="444"
                                                    src={settings?.youtube_link}
                                                    title="YouTube video player"
                                                    frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                    referrerPolicy="strict-origin-when-cross-origin"
                                                    allowFullScreen
                                                ></iframe>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td height="91">
                                                <div style={{ textAlign: "center" }}>
                                                    ถ่ายทอดสดการออกรางวัล สลากกินแบ่งรัฐบาล <br />
                                                    <strong>งวดวันที่ 16-08-2568</strong>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td height="160" style={{ backgroundColor: "#33FFFF" }}>
                                                <iframe
                                                    src="https://www.lottery.co.th/show"
                                                    width="100%"
                                                    height="340"
                                                    frameBorder="0"
                                                ></iframe>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td height="160" style={{ backgroundColor: "#33FFFF" }}>
                                                <div style={{ textAlign: "center" }}>
                                                    <a
                                                        href="https://logwork.com/countdown-jy9q"
                                                        className="countdown-timer"
                                                        data-style="columns"
                                                        data-timezone="Asia/Bangkok"
                                                        data-textcolor="#f02816"
                                                        data-date="2025-08-16 17:30"
                                                    >
                                                        เหลือเวลาเปิดระบบ
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </section>
            )}


            <footer class="footer">
                <div class="tf-container">
                    <div class="row ">
                        <div class="col-12 d-flex justify-content-center">
                            <div class="widget widget-infor">
                                {/* <div class="logo">
                                    <img id="logo_footer" src={logoImg} alt="profile" />
                                </div> */}
                                {/* <p class="content">Trade, Stake NFTs securely on MGP NFT Platform. Each qualified transaction with our massive prize pool of MCASH Crypto.</p> */}
                                <ul class="social-item">
                                    <li><a target='_blank' rel="noreferrer" href="https://twitter.com/mmsplatform/"><i class="fab fa-twitter"></i></a></li>
                                    <li><a target='_blank' rel="noreferrer" href="https://www.facebook.com/groups/417150759391621"><i class="fab fa-facebook"></i></a></li>
                                    <li><a target='_blank' rel="noreferrer" href="https://t.me/+W37uy4DFVqk5MTI1"><i class="fab fa-telegram-plane"></i></a></li>

                                </ul>
                                <p class="copy-right text-white">Copyright © {new Date().getFullYear()} MGP Lottery NFT. All Rights Reserved.

                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </footer>

            <NftModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                minStats={minStats}
                setUpdater={setUpdater}
                selectedNft={selectedNft}
                selectedId={selectedId}
            />
        </Layout>
    )
}
